module.exports = __webpack_public_path__ + "static/media/1004819.396a2478.png";